import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-we-have-been-in-the-news',
    templateUrl: './we-have-been-in-the-news.component.html',
    styleUrls: ['../../invest/home/invest.component.css', '../../../assets/styles/new-styles.css']
})
export class WeHaveBeenInTheNewsComponent {
    @Input()
    sectionColor: string;
}
